import { NAVIGATION_EVENT } from 'NavigateEventListener'
import { NavigateOptions } from 'react-router'

export interface RouterService {
  navigate: (to: string, options?: NavigateOptions) => void
}

export const routerService: RouterService = {
  navigate: (to, options) => {
    const navigateEvent = new CustomEvent(NAVIGATION_EVENT, {
      detail: {
        to,
        options
      }
    })

    document.dispatchEvent(navigateEvent)
  }
}
